import * as React from "react";
import { styled } from "@mui/material/styles";
import { TableCell, TableRow } from "@mui/material";
import { BaseTableCell, KeyValue, SimpleTableRow } from "../../interfaces";
import { AppUrl } from "../../config";
import { useNavigate } from "react-router-dom";

const PREFIX = "MultiTableBody";

const classes = {
  rowOnClick: `${PREFIX}-rowOnClick`,
  tableCell: `${PREFIX}-tableCell`,
  tableCellCheck: `${PREFIX}-tableCellCheck`,
};

const Root = styled(TableRow)({
  [`& .${classes.rowOnClick}`]: {
    "cursor": "pointer",
    "& td": {
      fontWeight: "bold",
    },
    "&:hover td, &:focus-visible td": {
      backgroundColor: "#C6EDF2",
    },
  },
  [`& .${classes.tableCell}`]: {
    maxWidth: 200,
  },
  [`& .${classes.tableCellCheck}`]: {
    "&.MuiTableCell-paddingCheckbox": {
      width: "fit-content",
      textAlign: "left",
    },
  },
});

interface Props {
  tableData: SimpleTableRow[];
  secondaryTableData: SimpleTableRow[][];
  bhcs?: boolean;
  appState?: any;
}

export default function MultiTableBody({
  tableData,
  secondaryTableData,
  bhcs,
  appState,
}: Props) {
  const isFR = appState.filters?.reportPeriod?.[0];
  const navigate = useNavigate();
  return (
    <>
      {tableData.map((tableCell: SimpleTableRow, index: number) => {
        return (
          <React.Fragment key={`${index}`}>
            <Root
              id={`simple-table-row-${index}`}
              tabIndex={0}
              onKeyPress={isFR ? undefined : tableCell.rowOnClick}
              onClick={isFR ? undefined : tableCell.rowOnClick}
              sx={{
                backgroundColor: "#ced6e3",
                cursor: !isFR && tableCell.rowOnClick ? "pointer" : "default",
                ...(bhcs &&
                  !isFR && {
                    "&:hover": {
                      backgroundColor: "#ACC8DF",
                    },
                  }),
              }}
              className={
                !isFR && tableCell.rowOnClick ? classes.rowOnClick : ""
              }
            >
              {Object.keys(tableCell).map((key: string, cellIndex: number) => {
                const value = (tableCell[key] as BaseTableCell).value;
                const apiField = (tableCell[key] as BaseTableCell)?.apiField;
                const fields = ["BKCLASS", "ASSET", "DEPDOM"];
                let hideExtras = false;
                if (apiField && fields.includes(apiField)) {
                  hideExtras = true;
                }
                return key !== "rowOnClick" ? (
                  <TableCell
                    className={classes.tableCell}
                    id={`${key}-${index}`}
                    key={`${key}`}
                    style={
                      isFR
                        ? {
                            color: "#1A4480",
                            fontWeight: "bold",
                            textAlign: (tableCell[key] as BaseTableCell).styles
                              .textAlign,
                            paddingLeft: (tableCell[key] as BaseTableCell)
                              .styles.paddingLeft,
                          }
                        : (tableCell[key] as BaseTableCell).styles
                    }
                  >
                    {isFR && hideExtras ? "" : value}
                  </TableCell>
                ) : undefined;
              })}
            </Root>
            {secondaryTableData[index] &&
              secondaryTableData[index].map(
                (tableCell: SimpleTableRow, secondaryIndex: number) => {
                  const cert = Array.isArray(tableCell)
                    ? tableCell.find(
                        (cell: KeyValue) => cell.apiField === "CERT",
                      )?.value
                    : undefined;
                  return (
                    <Root
                      id={`simple-tabl-secondary-row-${index}-${secondaryIndex}`}
                      key={`${index}-${secondaryIndex}`}
                      tabIndex={0}
                      sx={{
                        ...(isFR && {
                          "&:hover": {
                            backgroundColor: "#ACC8DF",
                          },
                        }),
                      }}
                      onClick={() => {
                        const reportUrl = `${AppUrl("FinancialReporting")}/report${window.location.search}`;
                        sessionStorage.setItem("prevUrl", reportUrl);
                        isFR &&
                          cert &&
                          navigate({
                            pathname: `${AppUrl("FinancialReporting")}/details/${cert}`,
                            search: appState.ui.limitInactiveDate
                              ? "?limitInactiveDate=true"
                              : `?reportPeriod=${isFR}`,
                          });
                      }}
                    >
                      {Object.keys(tableCell).map(
                        (key: string, cellIndex: number) => {
                          const value = (tableCell[key] as BaseTableCell).value;
                          const apiField = (tableCell[key] as BaseTableCell)
                            ?.apiField;
                          const fields = ["ASSET", "DEPDOM"];
                          let styleNumber = false;
                          if (apiField && fields.includes(apiField)) {
                            styleNumber = true;
                          }
                          return (
                            <TableCell
                              className={classes.tableCell}
                              id={`${key}-${index}`}
                              key={`${key}-${cellIndex}`}
                              style={
                                isFR
                                  ? {
                                      cursor: "pointer",
                                      color: "#0000EE",
                                      textDecoration: "underline",
                                      fontWeight: "bold",
                                      textAlign: (
                                        tableCell[key] as BaseTableCell
                                      ).styles.textAlign,
                                      paddingLeft: (
                                        tableCell[key] as BaseTableCell
                                      ).styles.paddingLeft,
                                    }
                                  : (tableCell[key] as BaseTableCell).styles
                              }
                            >
                              {styleNumber ? value.toLocaleString() : value}
                            </TableCell>
                          );
                        },
                      )}
                    </Root>
                  );
                },
              )}
          </React.Fragment>
        );
      })}
    </>
  );
}
